import { CustomerPortalInvoice, InvoiceStatusEnum } from '@monetize/types/app';
import { endOfDay } from 'date-fns/endOfDay';
import { isAfter } from 'date-fns/isAfter';
import { parseISO } from 'date-fns/parseISO';

/**
 * An invoice is past due when it is UNPAID and the due date has fully elapsed
 * (i.e. now is after the end of the due-date day). An invoice due today is not
 * yet past due.
 */
export const isInvoicePastDue = (invoice: CustomerPortalInvoice): boolean => {
  if (invoice.status !== InvoiceStatusEnum.UNPAID || !invoice.dueDate) {
    return false;
  }
  return isAfter(new Date(), endOfDay(parseISO(invoice.dueDate)));
};
